import React from 'react';
import PropTypes from 'prop-types';
import defaultStyles from './Message.module.scss';

const Message = props => (
    <div className={ props.styles.webJobsMessage }>{props.value} </div>
);

Message.propTypes = {
    value: PropTypes.string,
    styles: PropTypes.objectOf(PropTypes.string)
};

Message.defaultProps = {
    value: '',
    styles: defaultStyles
};

export default Message;
